import React from 'react';
import PropTypes from 'prop-types';

const Image = ({ image, remove }) => (
  <button className="chat-messenger_image-wrapper" onClick={() => remove()}>
    <img src={image.url} />
  </button>
);

Image.propTypes = {
  image: PropTypes.shape({}).isRequired,
  remove: PropTypes.func.isRequired,
};

export default Image;



// WEBPACK FOOTER //
// ./app/javascript/common/components/NewMessageImage/Image.js